import React from "react";
import { Button, Col, Container, Form, Row } from "react-bootstrap";
import { Facebook, Instagram, Linkedin, Twitter, Youtube } from "react-bootstrap-icons";
import { Link } from "react-router-dom";
import { enviroment } from "../../enviroment";
import { useAppStore } from "../../store";
import styles from "./Footer.module.css";
// Import JsonLd from react-schemaorg
import { JsonLd } from "react-schemaorg";
import Specials from "../Specials/Specials";

export const Footer = () => {
  const navItems = useAppStore((state) => state.navItems);

  return (
    <>
      {/* Organization Schema for Footer */}
      <JsonLd
        item={{
          "@context": "https://schema.org",
          "@type": "Organization",
          name: enviroment.BUSINESS_NAME,
          url: `${process.env.REACT_APP_URL}`,
          logo: `${process.env.REACT_APP_URL}/static/media/site_logo.e436b9d645cebd55240925a8147ce32b.svg`,
          description:
            `${enviroment.BUSINESS_NAME} specializes in selling open-box home and electronic appliances, offering high-quality products at deeply discounted prices.`,
          contactPoint: [
            {
              "@type": "ContactPoint",
              telephone: enviroment.MOBILE_NUMBER,
              contactType: "Customer Service",
              availableLanguage: "English",
              hoursAvailable: {
                "@type": "OpeningHoursSpecification",
                dayOfWeek: [
                  "Monday",
                  "Tuesday",
                  "Wednesday",
                  "Thursday",
                  "Friday",
                  "Saturday",
                ],
                opens: "11:00",
                closes: "19:00",
              },
            },
            {
              "@type": "ContactPoint",
              telephone: enviroment.MOBILE_NUMBER_2,
              contactType: "Customer Service",
              availableLanguage: "English",
              hoursAvailable: {
                "@type": "OpeningHoursSpecification",
                dayOfWeek: [
                  "Monday",
                  "Tuesday",
                  "Wednesday",
                  "Thursday",
                  "Friday",
                  "Saturday",
                ],
                opens: "11:00",
                closes: "19:00",
              },
            },
          ],
          sameAs: [
            enviroment.FACEBOOK_LINK || "",
            enviroment.TWITTER_LINK || "",
            enviroment.INSTAGRAM_LINK || "",
            enviroment.YOUTUBE_LINK || "",
            enviroment.LINKEDIN_LINK || "",
          ].filter((link) => link), // Filter out empty links
        }}
      />

      <footer className={styles.footer}>
        <Container>
          <Row className={styles.mainContent}>
            <Col lg={3} md={6} className={styles.footerColumn}>
              <h3 className={styles.columnTitle}>About</h3>
              <p className={styles.aboutText}>
                Ashi Electronics specializes in selling open-box home and electronic appliances, offering high-quality products at deeply discounted prices. The brand ensures that all items are thoroughly tested and certified for functionality and reliability, providing customers with excellent value for money. With a focus on affordability and sustainability, Ashi Electronics caters to smart shoppers looking for premium appliances at unbeatable deals.
              </p>
              <div className={styles.socialIcons}>
                {enviroment.FACEBOOK_LINK && (
                  <a href={enviroment.FACEBOOK_LINK} className={styles.socialLink}>
                    <Facebook />
                  </a>
                )}
                {enviroment.TWITTER_LINK && (
                  <a href={enviroment.TWITTER_LINK} className={styles.socialLink}>
                    <Twitter />
                  </a>
                )}
                {enviroment.INSTAGRAM_LINK && (
                  <a href={enviroment.INSTAGRAM_LINK} className={styles.socialLink}>
                    <Instagram />
                  </a>
                )}
                {enviroment.YOUTUBE_LINK && (
                  <a href={enviroment.YOUTUBE_LINK} className={styles.socialLink}>
                    <Youtube />
                  </a>
                )}
                {enviroment.LINKEDIN_LINK && (
                  <a href={enviroment.LINKEDIN_LINK} className={styles.socialLink}>
                    <Linkedin />
                  </a>
                )}
              </div>
            </Col>

            <Col lg={3} md={6} className={styles.footerColumn}>
              <h3 className={styles.columnTitle}>Categories</h3>
              <ul className={styles.footerLinks}>
                {navItems?.map((item, index) => (
                  <li key={index}>
                    <Link to={`/store/${item.name_url}`}>{item?.name}</Link>
                  </li>
                ))}
              </ul>
            </Col>

            <Col lg={3} md={6} className={styles.footerColumn}>
              <h3 className={styles.columnTitle}>Policies</h3>
              <ul className={styles.footerLinks}>
                <li><Link to="/about-us">About Us</Link></li>
                <li><Link to="/contact-us">Contact Us</Link></li>
                <li><Link to="/privacy-policy">Privacy Policy</Link></li>
                <li><Link to="/return-policy">Refund & Return Policy</Link></li>
                <li><Link to="/shipping-information-policy">Shipping Policy</Link></li>
                <li><Link to="/terms">Terms of Service</Link></li>
                <li><Link to="/cancellation-policy">Cancellation Policy</Link></li>
                <li><Link to="/faq">FAQ's</Link></li>
                <li><Link to="/sitemap">Sitemap</Link></li>
              </ul>
            </Col>

            <Col lg={3} md={6} className={styles.footerColumn}>
              <h3 className={styles.columnTitle}>Newsletter</h3>
              <p className={styles.newsletterText}>
                Stay updated with our latest offers and product news. Subscribe to our newsletter.
              </p>
              <Form className={styles.newsletterForm}>
                <Form.Control
                  type="email"
                  placeholder="Enter your email"
                  className={styles.emailInput}
                />
                <Button className={`${styles.subscribeButton} btn-gradient`}>Subscribe</Button>
              </Form>

              <div className={styles.contactInfo}>
                <h3 className={styles.columnTitle}>Contact Us</h3>
                <p>+91 9654502991, +91 9811931938</p>
                <p style={{ fontSize: "13px" }}>
                  Shop No. 4, Kaushik Complex,<br />
                  Sector 17, Near PNB Bank, Sukhrali,<br />
                  Gurgaon, Haryana 122001
                </p>
                <p>Monday to Saturday: 11:00 AM - 7:00 PM</p>
                <p>Sunday: Close</p>
              </div>
            </Col>
          </Row>

          <div className={styles.copyrightSection}>
            <p>© {new Date().getFullYear()} Ashi Electronics</p>
            <p>ashielectronics.com is a property of Ashi Retail Enterprises.</p>
            <p style={{ display: "none" }}>
              Developed & Marketed by{" "}
              <a href="https://rewardsplus.in" className="text-white" rel="noreferrer" target="_blank">
                RewardsPlus
              </a>
            </p>
          </div>
        </Container>
      </footer>
      <Specials />
    </>
  );
};